var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4082 0.231445C9.50496 0.134781 9.6581 0.134822 9.75488 0.231445L11.7568 2.23242C11.8488 2.32437 11.8611 2.45522 11.7744 2.59277L3.32422 11.043L3.16797 11.1211L0.476562 11.8408H0.401367C0.384945 11.8408 0.352312 11.8348 0.3125 11.8164C0.273705 11.7985 0.243116 11.7763 0.227539 11.7607C0.178187 11.7114 0.152228 11.6118 0.172852 11.5293L0.904297 8.80078L0.90918 8.78027V8.75977C0.90918 8.745 0.910447 8.73749 0.911133 8.73438C0.911588 8.73238 0.911909 8.73178 0.912109 8.73145C0.912762 8.7303 0.915293 8.72628 0.922852 8.71777C0.931017 8.7086 0.941359 8.69829 0.958008 8.68164L9.4082 0.231445ZM1.33887 8.99512L1.32812 9.03516L0.788086 11.0049L0.713867 11.2734L0.983398 11.2002L2.95215 10.6602L2.99316 10.6494L3.02246 10.6191L11.2354 2.40625L11.123 2.29395L9.69434 0.864258L9.58203 0.751953L1.33887 8.99512Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.31767
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e5144c64f455b0501081278d2fb5e5e.svg";
export { ForwardRef as ReactComponent };